import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, ArrowLeft, Loader2, Check } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (res.ok) {
        setSent(true);
        toast.success("Correo enviado");
      } else {
        const data = await res.json().catch(() => ({}));
        toast.error(data.detail || "Error al enviar el correo");
      }
    } catch {
      toast.error("Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center space-y-4" data-testid="forgot-password-success">
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <Check className="w-6 h-6 text-green-600" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-[#1B2B4D]">Correo enviado</h3>
        <p className="text-sm text-[#4A5568]">
          Si existe una cuenta con <strong>{email}</strong>, recibirás un enlace para restablecer tu contraseña.
        </p>
        <p className="text-xs text-[#718096]">Revisa también tu carpeta de spam.</p>
        <Button variant="ghost" onClick={onBack} className="mt-2" data-testid="back-to-login-btn">
          <ArrowLeft className="w-4 h-4 mr-1" /> Volver al inicio
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
      <div className="text-center mb-2">
        <h3 className="text-lg font-heading font-semibold text-[#1B2B4D]">Recuperar contraseña</h3>
        <p className="text-sm text-[#4A5568] mt-1">Ingresa tu correo y te enviaremos un enlace para restablecerla.</p>
      </div>
      <div>
        <Label htmlFor="reset-email" className="text-[#4A5568] text-sm">Correo electrónico</Label>
        <div className="relative mt-1">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A0AEC0]" />
          <Input
            id="reset-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@correo.com"
            className="pl-10"
            required
            data-testid="forgot-email-input"
          />
        </div>
      </div>
      <Button type="submit" disabled={loading} className="w-full bg-[#0066FF] hover:bg-[#0052CC]" data-testid="forgot-submit-btn">
        {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
        Enviar enlace de recuperación
      </Button>
      <Button type="button" variant="outline" onClick={onBack} className="w-full text-[#4A5568] border-[#E2E8F0]" data-testid="forgot-back-btn">
        <ArrowLeft className="w-4 h-4 mr-1" /> Volver al inicio de sesión
      </Button>
    </form>
  );
}
